<div class="ui-select" :class="[classStyle]" v-click-outside="handleFocusOut">
  <div class="select-block" @click.stop="onClick">
    <a href="javascript:;" class="selected-text" v-html="selected.isI18n ? t(selected.isI18n) : selected.text"
    :tabindex="isDisable ? -1 : 0"></a>
    <div :class="{'erroSpan' : error}"  v-if="isShowErrorTxt"> {{error}}</div>
  </div>
  <ul class="select-list-block" v-if="state.isOpen" tabinde="1">
    <template v-for="item in options">
      <li class="option" :value="item.val">
        <a href="javascript:;" class="text" :class="{'style--title':item.hasOwnProperty('sub')}"
          @click="onChange(item)" v-html="item.isI18n ?  t(item.isI18n):item.text"></a>
        <ul class="options-list-sub" v-if="item.hasOwnProperty('sub')">
          <li v-for="subOption in item.sub" :value="subOption.val">
            <a href="javascript:;" class="text" @click="onChange(subOption)">{{subOption.isI18n ? t(subOption.isI18n) : subOption.text}}</a>
          </li>
        </ul>
      </li>
    </template>
  </ul>

</div>